import { Downloading } from './downloading';

export default Downloading;
